import React, { useEffect, useMemo, useState } from 'react';
import { Form, notification, Row } from 'antd';
import {
  ScheduleTopicNotInvoicedResponse,
  getScheduleTopicNotInvoicedByCriteria,
  GetScheduleTopicNotInvoicedByCriteriaParams,
} from 'services/workflow';
import { useQuery } from 'react-query';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import ProposalSelect from 'components/ProposalSelect';
import { genClientInvoiceByContract } from 'services/clientInvoice';
import ButtonOperation from 'components/ButtonOperation';
import ModalControllerNV from 'components/ModalControllerNV';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import { dateToString } from 'utils/utils2';
import { toCurrency } from 'utils/utils';

const ScheduleTopicNotInvoicedList = () => {
  const [form] = Form.useForm();
  const fieldName = 'ScheduleTopicNotInvoicedResponse';

  const [search, setSearchs] = useState(false);

  const initialSearchParams: GetScheduleTopicNotInvoicedByCriteriaParams = {
    ctrid: '' as any,
    ctscategory: '',
    ctstype: '',
    datemax: '',
    datemin: '',
    tpid: '' as any,
    tpname: '',
    tpreference: '',
  };

  const [searchParams, setSearchParams] =
    useState<GetScheduleTopicNotInvoicedByCriteriaParams>(initialSearchParams);

  const { data, refetch } = useQuery(
    ['getScheduleTopicNotInvoicedByCriteria', searchParams],
    () =>
      getScheduleTopicNotInvoicedByCriteria(searchParams).then(
        (res) => res.list || []
      ),
    { enabled: search }
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        [fieldName]: data,
      });
    }
  }, [form, data]);

  const InvoiceHandleRunManual = (item: any, modet: string) => {
    genClientInvoiceByContract({
      ctridend: item.ctrid,
      ctridstart: item.ctrid,
      duedate:dateToString(item.ctsduedate),
      mode: modet,
      mgid:Number(localStorage.getItem('mgid'))
    }).then((response) => {
      if (response.code === '200') {
        notification.success({
          message: ' Client invoice created with success',
        });
        refetch();
      }
    });
  };

  const columns = useMemo<DataGridColDef<ScheduleTopicNotInvoicedResponse>[]>(
    () => [
      {
        comcode: 'entityreference',
        dataIndex: 'ctrid',
        filtrable: true,
        filterComponent: <ProposalSelect onlyctrid PropOrProd="PROD" phase="" />,
        render: (value, record) => (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a
                onClick={() => {
                  setVisible(true);
                }}
              >
                {record.entityreference}
              </a>
            )}
            modal={({ setVisible, visible }) => (
              <ProposalModal
                ctrid={record.ctrid}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
                title=""
                iscreate={false}

              />
            )}
          />
        ),
      },
      {
        comcode: 'ctstypelabel',
        dataIndex: 'ctstype',
        filtrable: true,
        filterComponent: <ParListSelect parcode="SCHINVTYPE" allowClear />,
        render: (value, record) => record.ctstypelabel,
      },
      {
        comcode: 'ctscategorylabel',
        dataIndex: 'ctscategory',
        filtrable: true,
        filterComponent: <ParListSelect parcode="SCHINVCAT" allowClear />,
        render: (value, record) => record.ctscategorylabel,
      },
      {
        dataIndex: 'ctsstatus',
      },
      {
        dataIndex: 'ctsstartdate',
      },
      {
        dataIndex: 'ctsenddate',
      },
      {
        dataIndex: 'ctsduedate',
      },
      {
        dataIndex: 'ctsterm',
      },
      {
        dataIndex: 'taxcode',
      },
      {
        dataIndex: 'ctsamortizedamount',
        width: 150,
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'ctsoutstandingamount',
        width: 150,
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'ctsstartamount',
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'ctsrentalamount',
         render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'action',
        width: '100px',
        fixed: 'right',
        render: (text, record) => (
          <Row>
            {record.ctstype === 'GRACE' ||record.ctstype === 'SERV' ||
            record.ctstype === 'FEES' ||
            record.ctstype === 'GPSERV' ||
            record.ctstype === 'FIRSTRENT' ||
            record.ctstype === 'RENTAL' ||
            record.ctstype === 'DEFINT' ? (
              <ButtonOperation
                onClick={() => InvoiceHandleRunManual(record, 'RENTAL')}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            ) : record.ctstype === 'RV' || record.ctstype === 'DEFINT' ? (
              <ButtonOperation
                onClick={() => InvoiceHandleRunManual(record, 'RV')}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            ) : record.ctstype === 'UPFRONT' ? (
              <ButtonOperation
                onClick={() => InvoiceHandleRunManual(record, 'UPFRONT')}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            ) : record.ctstype === 'EVENTFEES' ? (
              <ButtonOperation
                onClick={() => InvoiceHandleRunManual(record, 'EVENTFEES')}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            ) : record.ctstype === 'ASSETOUT' ? (
              <ButtonOperation
                onClick={() => InvoiceHandleRunManual(record, 'ASSETOUT')}
                comcode="runservice"
                type="primary"
                htmlType="submit"
              />
            ) : (
              ''
            )}
          </Row>
        ),
      },
    ],
    [refetch]
  );

  return (
    <DF.Provider pagcode="scheduletopicnotinvoiced">
      <Form form={form}>
        <Form.Item noStyle shouldUpdate>
          <DataGrid
            rowKey="id"
            dataSource={data}
            titleComcode="ScheduleTopicNotInvoiced"
            columns={columns}
            onSearch={(values) => {
              setSearchParams({
                ...searchParams,
                ...values,
                ctrid: values.ctrid,
              });
              setSearchs(true);
              refetch();
            }}
            onClear={() => {
              setSearchParams(initialSearchParams);
              form.resetFields();
              refetch();
            }}
            initialSearchValues={searchParams}
          />
        </Form.Item>
      </Form>
    </DF.Provider>
  );
};

export default ScheduleTopicNotInvoicedList;
